import {
    DELETE_ACCOUNT_YIELD,
    DELETE_ACCOUNT_YIELD_FAILURE,
    DELETE_ACCOUNT_YIELD_SUCCESS,
} from 'store/actions/types';

export const deleteAccountYield = (payload) => {
    return {
        type: DELETE_ACCOUNT_YIELD,
        payload: payload,
    };
};

export const deleteAccountYieldFailure = (error) => {
    return {
        type: DELETE_ACCOUNT_YIELD_FAILURE,
        error: error,
    };
};

export const deleteAccountYieldSuccess = (payload, response) => {
    return {
        type: DELETE_ACCOUNT_YIELD_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/account-yields/deleteAccountYields.js